/* eslint-disable react/no-array-index-key */
// Carousel.tsx
import React, { useState, useEffect } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import * as S from "./styles";

interface CarouselProps {
  slides: {
    image: string;
    href: string;
  }[];
}

export function Carousel({ slides }: CarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? (slides?.length || 1) - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) =>
      prev === (slides?.length || 1) - 1 ? 0 : prev + 1
    );
  };

  const goToSlide = (slideIndex: number) => {
    setCurrentIndex(slideIndex);
  };

  // Troca de slide a cada 5s
  useEffect(() => {
    const timer = setInterval(goToNext, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);

  return (
    <S.CarouselContainer>
      {/* Slide atual */}
      <S.SlideContainer
        style={{ backgroundImage: `url(${slides?.[currentIndex]?.image})` }}
      >
        {/* LINK que cobre toda a imagem */}
        <S.SlideLink
          href={slides?.[currentIndex]?.href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            if (!slides?.[currentIndex]?.href) e.preventDefault();
          }}
        >
          <S.Overlay />
        </S.SlideLink>
      </S.SlideContainer>

      {/* Botão: voltar */}
      <S.ArrowButtonLeft onClick={goToPrevious}>
        <IoIosArrowBack size={24} color="#2D5BFF" />
      </S.ArrowButtonLeft>

      {/* Botão: avançar */}
      <S.ArrowButtonRight onClick={goToNext}>
        <IoIosArrowForward size={24} color="#2D5BFF" />
      </S.ArrowButtonRight>

      {/* Dots (paginação) */}
      <S.DotsWrapper>
        {slides?.map((_, slideIndex) => (
          <S.Dot
            key={slideIndex}
            isActive={currentIndex === slideIndex}
            onClick={() => goToSlide(slideIndex)}
          />
        )) || null}
      </S.DotsWrapper>
    </S.CarouselContainer>
  );
}
